import pino from 'pino';
import * as Sentry from '@sentry/react-native';
import { createBrowserSentryTransmit, normalizeLevel } from '@fytness/shared';
import { env } from './env';

// React Native logger built on pino's browser build (Metro resolves pino's `browser` field). The
// console verbosity is gated by EXPO_PUBLIC_LOG_LEVEL; error-level logs are additionally forwarded
// to Sentry via the shared transmit hook (which scans both the merging object and positional args
// for an Error, so legacy message-first calls still capture an exception).
//
// Contingency: if pino ever fails to bundle under Metro, replace `root` with a loglevel-based shim
// that keeps this same `getLogger`/`logger` API, respects `env.logLevel`, and calls
// `createBrowserSentryTransmit(Sentry).send` from its `error` path — no call site changes needed.
const root = pino({
  level: normalizeLevel(env.logLevel),
  browser: {
    asObject: true,
    transmit: createBrowserSentryTransmit(Sentry),
  },
});

export const getLogger = (name: string) => root.child({ context: name });

// Back-compat default logger used across the app (loglevel-compatible call sites still work).
export const logger = root;
